<script lang="ts">
    import VVMWindrose from '$lib/assets/vectors/VVMWindrose.svelte';
    import Footer from '$lib/components/navigation/Footer.svelte';
    import ReducedMainNavbar from '$lib/components/navigation/ReducedMainNavbar.svelte';
    import Button from '$lib/daisyUiComponents/ButtonVV.svelte';
    import JsCookies from 'js-cookie';
    import { fade } from 'svelte/transition';
    import { t } from 'svelte-i18n';
    import AwardFeinschmeckerImg from '$lib/assets/images/awards/award_feinschmecker.png?as=run:0&format=avif;webp;png';
    import AwardMeiningerImg from '$lib/assets/images/awards/award_meininger.png?as=run:0&format=avif;webp;png';
    import AwardVinumImg from '$lib/assets/images/awards/award_vinum.png?as=run:0&format=avif;webp;png';
    import AwardWeinPlusImg from '$lib/assets/images/awards/award_weinplus.png?as=run:0&format=avif;webp;png';
    import Img from '@zerodevx/svelte-img';
    import { AGE_CHECK_COOKIE_NAME } from '$lib/cookies.js';

    function setAgeCookie(value: string) {
        JsCookies.set(AGE_CHECK_COOKIE_NAME, value, {
            expires: 365, // days
            path: '/',
            sameSite: 'lax',
            secure: false,
            httpOnly: false
        });

        window.location.reload();
    }

    export let ageCookie: string | undefined;
</script>

<ReducedMainNavbar />

<section
    transition:fade={{ duration: 100 }}
    class="font-jost w-full h-full min-h-screen bg-neutral flex flex-col items-center px-5"
>
    <div
        class="absolute top-[calc(-50%+120px)] md:top-8 2xl:top-0 left-0 w-full h-full flex justify-center items-center overflow-hidden"
    >
        <VVMWindrose />
    </div>

    <div class="z-10 text-center w-full grow flex flex-col justify-center mt-32 mb-14">
        {#if ageCookie === undefined}
            <h1
                class="text-[2.56rem] sm:text-[2.62rem] md:text-[2.68rem] lg:text-[2.74rem] xl:text-[2.8rem] 2xl:text-[2.875rem] font-cinzel uppercase text-chamois leading-[1.15em] tracking-[0.03em] mb-3"
            >
                {$t('shop.ageCheck.title')}
            </h1>
            <p class="max-w-[51.5rem] mx-auto text-base md:text-17px leading-[1.59rem] tracking-[0.02em] text-grey">
                {$t('shop.ageCheck.content')}
            </p>
            <div class="flex gap-3 mt-6 md:mt-9 w-full justify-center">
                <Button color="primary" btnStyle="outline" class="w-24" on:click={() => setAgeCookie('true')}
                    >{$t('shop.ageCheck.yes')}</Button
                >
                <Button color="primary" btnStyle="outline" class="w-24" on:click={() => setAgeCookie('false')}
                    >{$t('shop.ageCheck.no')}</Button
                >
            </div>
        {:else if ageCookie === 'false'}
            <h1
                class="text-[2.56rem] sm:text-[2.62rem] md:text-[2.68rem] lg:text-[2.74rem] xl:text-[2.8rem] 2xl:text-[2.875rem] font-cinzel uppercase text-chamois leading-[1.15em] tracking-[0.03em] mb-3"
            >
                {$t('shop.ageCheck.quote')}
            </h1>
            <div class="max-w-[51.5rem] text-base md:text-17px leading-[1.59rem] tracking-[0.02em] text-grey mx-auto">
                <p>
                    {$t('shop.ageCheck.disclaimer')}
                </p>
                <p class="mt-2">
                    {$t('shop.ageCheck.info')}
                </p>
            </div>

            <div class="flex flex-row flex-wrap gap-y-4 gap-3 mt-10 sm:mt-8 w-full justify-center">
                <Button href="mailto:office@vanvolxem.com" color="primary" class="grow sm:grow-0" btnStyle="outline"
                    >office@vanvolxem.com</Button
                >
                <Button href="tel:+496501802290" color="primary" class="grow sm:grow-0" btnStyle="outline"
                    >+49 6501 80229-0</Button
                >
            </div>
        {/if}
    </div>

    <div class="mb-8 flex justify-center gap-5 sm:gap-4 md:gap-6 2xl:gap-16 w-full">
        <div class="flex flex-col sm:flex-row items-center gap-5 sm:gap-4 md:gap-6 lg:gap-6 2xl:gap-16">
            <Img src={AwardWeinPlusImg} />
            <Img src={AwardMeiningerImg} />
        </div>

        <div class="flex flex-col sm:flex-row items-center gap-5 sm:gap-4 md:gap-6 lg:gap-6 2xl:gap-16">
            <Img src={AwardFeinschmeckerImg} />
            <Img src={AwardVinumImg} />
        </div>
    </div>
</section>

<Footer />
